<template>
  <div id="header">
    <md-toolbar class="toolbar" :class="getHeaderClass" style="padding-left: 0; transition: .3s">
      <div class="header-back-logo" id="back-button" :style="getHeaderClass == 'dark' ? (routeName == 'session' ? 'width: 100px' : 'width:100px') : ''" :class="$route.params.slug != 'holacon' ? 'wlabelclass' : ''">
        <img v-if="$route.params.slug != 'holacon'" :src="$imageus + $store.state.application.image + '?width=200&height=200)'" class="logo wlabel" style="cursor: pointer" :style="getHeaderClass == 'dark' ? 'height: 40px' : 'width: 40px;'" @click="$router.push({ name: 'events' })" />
        <img v-else :src="getHeaderClass == 'dark' ? '/static/logo_white.svg' : '/static/logo.svg'" class="logo" style="cursor: pointer" :style="getHeaderClass == 'dark' ? 'height: 30px' : 'width: 120px;'" @click="$router.push({ name: 'events' })" />
        <button v-if="$route.params.id != undefined" @click="goBack" style="outline: none; border: none; color: white; background: none; font-size: 20px; cursor: pointer; display: flex; flex: 1; text-align: center; align-items: center; justify-content: center">
          <i class="fa fa-chevron-left"></i>
          <md-tooltip md-delay="300">Geri Dön</md-tooltip>
        </button>
      </div>
      <div class="w-100">
        <AccountBlock />
      </div>
    </md-toolbar>
  </div>
</template>

<script>
import axios from "axios";
import DownloadApp from "./DownloadApp";
import InfiniteLoading from "vue-infinite-loading";
import AccountBlock from "../modules/AccountBlock";
import moment from "moment/min/moment-with-locales";
import $ from "jquery";
import _ from "lodash";
export default {
  name: "Header",
  components: {
    DownloadApp,
    AccountBlock,
    InfiniteLoading
  },
  data() {
    return {
      ok: true,

      downloadApp: false,
      routeName: this.$route.name,
      isOpen: localStorage.getItem("isOpen") == null ? true : localStorage.getItem("isOpen") == "true",
      localStorage
    };
  },

  watch: {
    "$route.name": function() {
      this.routeName = this.$route.name;
      window.scrollTo(0, 0);
    }
  },

  computed: {
    getHeaderClass() {
      if (this.routeName == "home" || this.routeName == "events" || this.routeName == "incomingevents" || this.routeName == "pastevents") {
        return "light";
      }
      return "dark";
    },
    getCurrentSession() {
      if (this.routeName == "session") {
        return this.$store.state.sessions.find(k => k.id == this.$route.params.session_id);
      }
      return null;
    }
  },

  methods: {

    goBack() {
      if (this.$route.name == "session") {
        this.$router.push({ name: "livestreams" });
      } else if (this.$route.name == "room") {
        this.$router.push({ name: "networking" });
      } else if (this.$route.name == "booth") {
        this.$router.push({ name: "stands" });
      } else if (this.$route.name == "event") {
        this.$router.push({ name: "home" }).catch(e => {});
      } else {
        this.$router.push({ name: "home" }).catch(e => {});
      }
    }
  }
};
</script>

<style>
.v-tour {
  z-index: 999999;
}
</style>

<style lang="less">
#header {
  .light {
    background-color: #fff;
    min-height: 55px;
  }
  .dark {
    display: none !important;
    height: 0px;
  }

  .logo {
    height: 30px;

    &.wlabel {
      height: 40px;
      width: 40px;
      aspect-ratio: 1;
    }
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-back-logo {
      width: 150px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.wlabelclass {
        width: auto;
        height: 40px;
        width: 40px;
        aspect-ratio: 1;
        border-radius: 8px;
        box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 6px;
        overflow: hidden;
        margin-left: 20px;
      }
    }
  }

  .acc-button .md-ripple .md-button-content {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
}

@media (max-width: 768px) {
  #header {
    .toolbar {
      .header-back-logo {
        display: none !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/Header.vue